fragment PreferenceCenterAudience on Audience {
    id
    name
    publicName
    description
    publicDescription
    isPublic
    htmlUrlPath
    deletedTime
    lastContactedTime
    membershipStats {
        subscribedCount
        totalCount {
            value
            suffix
            prefix
            formatted
        }
    }
}
